import { Modal, Button } from 'react-bootstrap';
import { CircleCheckBox } from '../form/CircleCheckBox';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dismiss_popupActions } from '../../actions';
import { popupDismissConstants } from '../../constants';

const isNotPassed = (date) => {
  return date ? new Date(date) > new Date() : false;
}

const DismissMessage = ({
    isChecked, setIsChecked
}) => {
    const message = "Don't show this again for 5 minutes";
    const dispatch = useDispatch();

    return (
        <div 
            className='d-flex align-items-center mb-12px dismiss-message cursor-pointer' 
            onClick={() => setIsChecked(prev => !prev)}
        >
            <CircleCheckBox height={18} width={18} isChecked={isChecked} /> 
            <p className='mb-0'>{message}</p>
        </div>
    );
}

const DismissablePopup = ({
  show,
  onClose,
  title,
  message,
  onConfirm,
  confirmBtnVariant = "orange",
  confirmText = "Yes",
  cancelText = "Cancel",
  dismissable = true,
  cancelBtn = true
}) => {
  // Variables
  const dispatch = useDispatch();
  const DISMISS_TIME = 5 * 60 * 1000; // 5 minutes

  // States
  const [isChecked, setIsChecked] = useState(false);

  // Redux
  const { data, id } = useSelector(state => state.popup_dismiss);

  // Functions
  const handleSubmit = () => {
    if(isChecked && dismissable){
      const formData = {
        dismiss_until: new Date(new Date().getTime() + DISMISS_TIME) 
      }

      const onSuccess = (response) => {
        dispatch({ type: popupDismissConstants.SET_POPUP_DISMISS, payload: response.data.data });
      }

      dispatch(dismiss_popupActions.updateDismissPopupDetail({ formData, id, onSuccess }));
    }

    onConfirm();
  };

  // Effects
  
  useEffect(() => {
    if(data === null && show === false){

      const onSuccess = (response) => {
        dispatch({ type: popupDismissConstants.SET_POPUP_DISMISS, payload: response.data.data });
      }

      dispatch(dismiss_popupActions.getDismissPopupDetail({onSuccess}));
    }

    if(show && dismissable){
      const is_not_passed = isNotPassed(data?.dismiss_until);
      if (is_not_passed) {
        onConfirm();
        onClose();
      }
    }
  }, [show, data]);

  return (
    <Modal 
        className='dismissable_popup' 
        show={show} 
        onHide={onClose}
    >
      <Modal.Header>
        { title ?  <Modal.Title>{title}</Modal.Title> : null}
      </Modal.Header>
      <Modal.Body className='box-shadow'>
        <p className='mb-12px'>{message}</p>
        { dismissable && <DismissMessage isChecked={isChecked} setIsChecked={setIsChecked} /> }

        <div className='d-grid'>
            <Button 
                className='mb-6px h-30px fw-500' 
                variant={confirmBtnVariant}
                size={'sm'} 
                onClick={handleSubmit}
            >
                {confirmText}
            </Button>

            {
              cancelBtn && (
                <Button 
                    className='h-30px border-0 fw-500' 
                    variant="white" 
                    size={'sm'} 
                    onClick={onClose}
                >
                    {cancelText}
                </Button>
              )
            }
        </div>
      </Modal.Body>
    </Modal>
  );
};

export { DismissablePopup };